<i18n src="@/locales/modules/CustomerTranslate.json"></i18n>

<template>
	<div>
		<el-dialog class="custom-dialog todo-detail-dialog" append-to-body destroy-on-close :visible.sync="isSidebarActiveLocal">
			<div slot="title" class="flex justify-between items-center w-full">
				<span class="el-dialog__title break-normal">{{ $t("DetailCustomer") }}</span>
				<CustomerContextMenu class="mr-2" :customerItem="data" @onClickAddDebts="data => $emit('onClickAddDebts', data)" @onClickEdit="data => $emit('onClickEdit', data)" />
			</div>
			<div>
				<el-collapse v-model="activeGeneral" class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">{{ $t("CustomerInfo") }}</h6>
						</template>
						<div class="p-6 pb-0" v-if="data">
							<div>
								<vs-row class="mb-1" v-if="getCustomerDecentralizedAccess(data.c_permissions, 'group', 'view')">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1 text-base">Nhóm khách hàng:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black text-base">{{ data.group }}</vs-col>
								</vs-row>
								<vs-row class="mb-1">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1 text-base">Mã khách hàng:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black text-base">{{ data.code }}</vs-col>
								</vs-row>
								<vs-row class="mb-1" v-if="getCustomerDecentralizedAccess(data.c_permissions, 'name', 'view')">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1 text-base">Tên khách hàng:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black text-base">{{ data.name }}</vs-col>
								</vs-row>
								<vs-row class="mb-1" v-if="getCustomerDecentralizedAccess(data.c_permissions, 'debt_limit', 'view')">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1 text-base">Hạn mức cho phép:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black text-base">{{ $helper.numFormat(data.debt_limit) }}</vs-col>
								</vs-row>
								<vs-row class="mb-1" v-if="getCustomerDecentralizedAccess(data.c_permissions, 'cmnd', 'view')">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1 text-base">CMND/CCCD:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black text-base">{{ data.cmnd }}</vs-col>
								</vs-row>
								<vs-row class="mb-1" v-if="getCustomerDecentralizedAccess(data.c_permissions, 'cmnd', 'view')">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1 text-base">Passport:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black text-base">{{ data.passport_no }}</vs-col>
								</vs-row>
								<vs-row class="mb-1" v-if="getCustomerDecentralizedAccess(data.c_permissions, 'name', 'view')">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1 text-base">Giới tính:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black text-base">{{ data.gender == 1 ? 'Nam' : (data.gender == 0 ? 'Nữ' : '-') }}</vs-col>
								</vs-row>
								<vs-row class="mb-1" v-if="getCustomerDecentralizedAccess(data.c_permissions, 'name', 'view')">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1 text-base">Năm sinh:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black text-base">{{ data.dob }}</vs-col>
								</vs-row>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="DebtInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">
								{{ $t("DebtInfo") }}
								<span v-if="getCustomerDecentralizedAccess(data.c_permissions, 'debt_current', 'view')" class="font-normal">
									({{ $t("Summary") }}: {{ $helper.numFormat(data.debt_current) }})
								</span>
							</h6>
						</template>
						<div class="px-3">
							<vs-table ref="table" class="stack-table" :sst="true" :data="$store.state.customerManagement.debts" :noDataText="$t('Notify.NoDataAvailable')" @sort="handleSort">
								<template slot="thead">
									<vs-th class="no-sorter">
										<h6 class="font-medium uppercase">{{ $t("IssueDate") }}</h6>
									</vs-th>
									<vs-th sort-key="deaddate">
										<h6 class="font-medium uppercase">{{ $t("DeadDate") }}</h6>
									</vs-th>
									<vs-th sort-key="overdays" class="custom-sort-filter">
										<h6 class="font-medium uppercase">{{ $t("OverDays") }}</h6>
									</vs-th>
									<vs-th sort-key="debt" class="w-1/3">
										<h6 class="font-medium uppercase w-full text-right">{{ $t("Debt") }}</h6>
									</vs-th>
								</template>

								<template slot-scope="{ data }">
									<tbody>
										<vs-tr class="cursor-default" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
											<vs-td :data-header="$t('IssueDate')">
												<p v-if="tr.issued_date" class="text-base">{{ tr.issued_date | dateTime("DD/MM/YYYY") }}</p>
											</vs-td>
											<vs-td :data-header="$t('DeadDate')">
												<p class="text-base">{{ tr.deadline_date | dateTime("DD/MM/YYYY") }}</p>
											</vs-td>

											<vs-td :data-header="$t('OverDays')">
												<p class="text-base text-base w-full text-right">{{ $helper.numFormat(tr.paid_days) }}</p>
											</vs-td>

											<vs-td :data-header="$t('Debt')">
												<h5 class="w-full text-right font-bold">{{ $helper.numFormat(tr.amount) }}</h5>
												<p class="text-base w-full text-right">{{ tr.debt_age }}</p>
											</vs-td>
										</vs-tr>
									</tbody>
								</template>
							</vs-table>
							<CbsPagination class="mt-3" :total="totalPages" v-model="page" />
						</div>
					</el-collapse-item>
				</el-collapse>

				<!-- History -->

				<!-- Logs -->
				<el-collapse @change="toggleLogs" id="logs-customer-with-loading" class="vs-con-loading__container cbs-collapse">
					<el-collapse-item>
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">{{ $t("Logs") }}</h6>
						</template>
						<div class="px-6 py-3" v-for="(log, index) in logs" :key="`logitem${index}`">
							<div class="flex flex-wrap justify-between">
								<h6 class="font-bold">{{ log.user.first_name }}</h6>
								<p>{{ log.created_at | dateTime(userDateTimeFormat) }}</p>
							</div>
							<p class="text-black">{{ log.content }}</p>
						</div>
						<h6 v-if="logs.length === 0" class="text-center px-6 py-3">{{ $t("Notify.NoDataAvailable") }}</h6>
					</el-collapse-item>
				</el-collapse>

				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="DebtInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">
								LỊCH SỬ KHÁM BỆNH
							</h6>
						</template>
						<div class="px-3">
							<vs-table ref="table" class="stack-table" :sst="true" :data="ytes" :noDataText="$t('Notify.NoDataAvailable')" @sort="handleSort">
								<template slot="thead">
									<vs-th class="no-sorter">
										<h6 class="font-medium uppercase">Ngày khám</h6>
									</vs-th>
									<vs-th sort-key="deaddate">
										<h6 class="font-medium uppercase">Bệnh viện khám</h6>
									</vs-th>
									<vs-th sort-key="overdays" class="custom-sort-filter">
										<h6 class="font-medium uppercase">Đơn vị tổ chức tour</h6>
									</vs-th>
									<vs-th sort-key="overdays" class="custom-sort-filter">
										<h6 class="font-medium uppercase"></h6>
									</vs-th>
								</template>

								<template slot-scope="{ data }">
									<tbody>
										<vs-tr class="cursor-pointer" :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click.native="handleClickItemRow($event, tr)">
											<vs-td :data-header="$t('IssueDate')">
												<p class="text-base">{{ tr.checkin_date | dateTime("DD/MM/YYYY") }}</p>
											</vs-td>
											<vs-td :data-header="$t('IssueDate')">
												<p class="text-base">{{ tr.info.ttdv_ten_benh_vien }}</p>
											</vs-td>
											<vs-td :data-header="$t('IssueDate')">
												<p class="text-base">{{ tr.info.tt_chuyen_di_dv_to_chuc_tour }}</p>
											</vs-td>
											<vs-td :data-header="$t('IssueDate')">
												<cbs-download-button class="mr-3" :btnText="'Tải về'" @click.stop="handleDownloadReport(tr.id)" />
											</vs-td>
										</vs-tr>
									</tbody>
								</template>
							</vs-table>
							<CbsPagination class="mt-3" :total="totalYtesPages" v-model="page" />
						</div>
					</el-collapse-item>
				</el-collapse>
			</div>
		</el-dialog>
		<CustomerTTYTDetail
			v-if="customerTTYTDialogData"
			:data="customerTTYTDialogData"
			:infoData="customerTTYTDialogData"
			:isSidebarActive="isCustomerTTYTDetailDialogActive"
			@closeSidebar="closeCustomerTTYTDetail"
		/>
		<CustomerTTYTFormSideBar
			v-if="formTTYTData"
			:data="formTTYTData"
			:infoData="formTTYTDataInfo"
			:isSidebarActive="isFormTTTYActive"
			@closeSidebar="closeCustomerTTYTForm"
			:key="formTTYTDataInfoId"
		/>
	</div>
</template>
<script>
import CustomerContextMenu from "./CustomerContextMenu";
import todoListGql from "@/http/requests/cbs/todo_list_gql";
import CustomerTTYTDetail from "./CustomerTTYTDetail";
import CustomerTTYTFormSideBar from "./CustomerTTYTFormSideBar";
import customerGql from "@/http/requests/card/customer_gql";

export default {
	name: "CustomerDetailDialog",
	components: { CustomerContextMenu, CustomerTTYTDetail, CustomerTTYTFormSideBar },
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		customer: {
			type: Object,
			default: () => {}
		}
	},

	data() {
		return {
			activeGeneral: ["GeneralInfo"],
			debts: [],
			page: 1,
			limitPerPage: 10,
			logs: [],
			ytes: [],
			totalYtePages: 0,
			isCustomerTTYTDetailDialogActive: false,
			customerTTYTDialogData: null,
			formTTYTData: null,
			formTTYTDataInfo: null,
			isFormTTTYActive: false,
			formTTYTDataInfoId: 0,
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},
		totalPages() {
			return Math.ceil(this.$store.state.customerManagement.debtsTotal / this.limitPerPage);
		},
		totalYtesPages() {
			return Math.ceil(this.totalYtePages / this.limitPerPage);
		},
		data() {
			return this.$store.getters["customerManagement/getCustomer"](this.customer.id);
		}
	},
	watch: {
		page() {
			this.getCustomerDetailDebts();
		}
	},
	methods: {
		async handleDownloadReport(id) {
			console.log('handleDownloadReport: ', id);
			try {
				this.$vs.loading();
				const response = await customerGql.downloadTTYT(id);
				const fileName = response.split("/");
				await this.handleDownloadFile({
					path: response,
					file_name: fileName[fileName.length - 1]
				});
			} catch (error) {
				console.error("handleDownloadReport", error);
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		closeCustomerTTYTDetail() {
			this.isCustomerTTYTDetailDialogActive = false;
		},
		closeCustomerTTYTForm() {
			this.isFormTTTYActive = false;
		},
		handleClickItemRow(event, data) {
			// console.log('handleClickItemRow: ', data);
			if (this.customer.can_update_accessables) {
				this.formTTYTData = this.customer;
				this.formTTYTDataInfo = data;
				this.isFormTTTYActive = true;
				this.formTTYTDataInfoId = data.info.id;
			} else {
				this.customerTTYTDialogData = data;
				this.isCustomerTTYTDetailDialogActive = true;
			}
		},
		async getCustomerDetailDebts() {
			const payload = {
				limit: this.limitPerPage,
				page: this.page,
				customer_id: this.data.id
			};
			await this.$store.dispatch("customerManagement/getCustomerYtes", payload);
		},
		async getCustomerYtes() {
			const payload = {
				limit: this.limitPerPage,
				page: this.page,
				customer_id: this.data.id
			};
			const ytes = await this.$store.dispatch("customerManagement/getCustomerYtes", payload);
			// console.log(ytes);
			let data = [];
			if (ytes && ytes.customer_ytes) {
				for (let k in ytes.customer_ytes) {
					let yte = ytes.customer_ytes[k];
					if (yte) {
						if (yte.info) {
							yte.info = JSON.parse(yte.info);
							yte.info.id = yte.id;
						}
						data.push(yte);
					}
				}
			}
			// console.log('data: ', data);
			this.ytes = data;
			this.totalYtePages = ytes.total || 0;
		},
		handleSort() {},
		async getLogs(id) {
			this.$vs.loading({
				container: "#logs-customer-with-loading",
				scale: 0.6
			});

			const dataTodoLogs = await todoListGql.fetchTodoLogs({ relation_id: id, relation_type: "Customer" });
			this.$vs.loading.close("#logs-customer-with-loading > .con-vs-loading");

			if (dataTodoLogs && dataTodoLogs.logs) {
				this.logs = dataTodoLogs.logs;
			}
		},
		toggleLogs(ev) {
			if (ev.length > 0 && this.logs.length === 0) {
				this.getLogs(this.data.id);
			}
		}
	},
	created() {
		this.getCustomerDetailDebts();
		this.getCustomerYtes();
	}
};
</script>
<style lang="scss">
.el-radio-button__inner {
	width: 100%;
	border: none;
	border-radius: 0 0 0 0 !important;
}
[dir] .el-radio-button__inner {
	background: #e0e0e0;
}
</style>
